import React, { useEffect } from 'react';
import { ArrowRight, ShieldCheck, Clock, User, Star } from 'lucide-react';
import { useFormContext } from './FormContext';
interface WelcomeScreenProps {
  onStart: () => void;
}
export const WelcomeScreen: React.FC = () => {
  const {
    goToNextStep
  } = useFormContext();
  // Add fade-in animation classes
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-fade-in');
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('opacity-100');
        el.classList.remove('opacity-0', 'translate-y-4');
      }, 100 * index);
    });
  }, []);
  return <div className="p-0" data-id="element-1338">
      <div className="p-10 md:p-16 text-center" data-id="element-1339">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iNLk3EmxWWeDcZfjJkYtHX/Veranova_Logo.png" alt="Veranova" className="h-20 mx-auto mb-8 animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1340" />
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1341">
          Configureer uw <span className="text-[#CDA735]" data-id="element-1342">droomveranda</span>
        </h1>
        <p className="text-xl text-white/90 mb-10 max-w-xl mx-auto animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1343">
          In enkele stappen naar een persoonlijke offerte op maat. Geen
          verplichtingen, volledig vrijblijvend.
        </p>
        <div className="flex flex-col md:flex-row gap-4 justify-center mb-10 animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1344">
          <div className="flex items-start bg-white/10 p-4 rounded-lg hover:bg-white/15 transition-colors" data-id="element-1345">
            <ShieldCheck className="h-6 w-6 text-[#CDA735] mt-1 flex-shrink-0" data-id="element-1346" />
            <span className="ml-3 text-white/90 text-left" data-id="element-1347">
              Vrijblijvend advies zonder verplichtingen
            </span>
          </div>
          <div className="flex items-start bg-white/10 p-4 rounded-lg hover:bg-white/15 transition-colors" data-id="element-1348">
            <Clock className="h-6 w-6 text-[#CDA735] mt-1 flex-shrink-0" data-id="element-1349" />
            <span className="ml-3 text-white/90 text-left" data-id="element-1350">
              Snelle reactie binnen 48 uur
            </span>
          </div>
        </div>
        {/* Testimonial */}
        <div className="bg-white/10 rounded-lg p-6 mb-10 max-w-xl mx-auto animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1351">
          <div className="flex items-center mb-3" data-id="element-1352">
            <div className="flex text-[#CDA735]" data-id="element-1353">
              <Star className="h-4 w-4 fill-current" data-id="element-1354" />
              <Star className="h-4 w-4 fill-current" data-id="element-1355" />
              <Star className="h-4 w-4 fill-current" data-id="element-1356" />
              <Star className="h-4 w-4 fill-current" data-id="element-1357" />
              <Star className="h-4 w-4 fill-current" data-id="element-1358" />
            </div>
            <span className="ml-2 text-white/80 text-sm" data-id="element-1359">5.0 / 5.0</span>
          </div>
          <p className="text-white/90 italic mb-4" data-id="element-1360">
            "Dankzij de heldere configurator kon ik precies aangeven wat ik
            wilde. De offerte was snel binnen en de veranda is prachtig
            geworden!"
          </p>
          <div className="flex items-center" data-id="element-1361">
            <div className="bg-[#CDA735]/20 rounded-full p-2 mr-3" data-id="element-1362">
              <User className="h-4 w-4 text-[#CDA735]" data-id="element-1363" />
            </div>
            <div className="text-left" data-id="element-1364">
              <p className="text-white font-medium text-sm" data-id="element-1365">Johan de Vries</p>
              <p className="text-white/60 text-xs" data-id="element-1366">
                Veranda met glazen schuifwanden
              </p>
            </div>
          </div>
        </div>
        <button onClick={goToNextStep} className="bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-8 py-4 rounded-md shadow-lg hover:shadow-[0_0_30px_rgba(205,167,53,0.4)] transition-all duration-300 inline-flex items-center text-lg group animate-fade-in opacity-0 translate-y-4 transition-all duration-700" data-id="element-1367">
          <span data-id="element-1368">Start configuratie</span>
          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-1369" />
        </button>
      </div>
    </div>;
};